<template>
  <div class>
    <div class="searchbox">
      <form action="#" method="get" class="form-inline form-float">
        <div class="form-group">
          <label for>登录账号：</label>
          <el-input v-model="search.name" placeholder="登录账号"></el-input>
        </div>
        <div class="form-group">
          <label for="bdate">时间</label>
          <el-date-picker
            value-format="yyyy-MM-dd HH:mm:ss"
            :editable="false"
            v-model.trim="search.startTime"
            type="datetime"
            placeholder="选择日期时间"
          ></el-date-picker>
        </div>
        <div class="form-group">
          <label for="edate">至</label>
          <el-date-picker
            value-format="yyyy-MM-dd HH:mm:ss"
            :editable="false"
            v-model.trim="search.endTime"
            type="datetime"
            placeholder="选择日期时间"
          ></el-date-picker>
        </div>
        <div class="form-group others">
          <span class="search_btn">
            <button @click="searchList" type="button" class="btn btn-primary" id="search_btn">查询</button>
          </span>

          <!-- <span class='refresh_btn'><Refresh @tableList="this.tableList"></Refresh></span> -->
        </div>
      </form>
    </div>

    <div class="list-right">
      <el-table
        ref="table"
        border
        :data="tableListData.rows"
        height="100%"
        :header-cell-style="tableHeaderStyle"
        :cell-style="styleObj"
      >
        <el-table-column show-overflow-tooltip label="序号" prop="infoId"></el-table-column>
        <el-table-column show-overflow-tooltip label="登录账号" prop="loginName"></el-table-column>
        <el-table-column show-overflow-tooltip label="登录IP" prop="ipaddr"></el-table-column>
        <el-table-column show-overflow-tooltip label="登录地址" prop="loginLocation"></el-table-column>
        <el-table-column show-overflow-tooltip label="登录时间" prop="crtTime"></el-table-column>
        <!-- <el-table-column  show-overflow-tooltip
					label="登出时间"
					prop="loginOutTime"
				>
        </el-table-column>-->
        <!-- <el-table-column  show-overflow-tooltip
					label="备注"
				>
        </el-table-column>-->
      </el-table>
    </div>

    <!-- <Page :pageSize="search.pageSize"></Page> -->
    <Page v-on:pagination="receivePaginationData"></Page>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

import { dictValue, getconlog } from "@/api/url";

import Page from "../../commons/page.vue";

import Refresh from "../../commons/refresh.vue";

export default {
  data() {
    return {
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      allOrderType: [],
      search: {
        pageNumber: 1,
        pageSize: 10,
        status: "",
        name: "",
        startTime: "",
        endTime: "",
      },
      photo: {},
      tableListData: {
        rows: [],
      },
      tableListDataAll: {},
      downloadFileds: {
        登录账号: "userName",
        登录IP: "loginIp",
        登录时间: "loginInTime",
        登出时间: "loginOutTime",
      },
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },
    tableList: function (curPage) {
      var _this = this;
      this.$get(getconlog(), {
        loginName: this.search.name,
        limit: this.search.pageSize,
        page: curPage,
        beginTime: this.search.startTime,
        endTime: this.search.endTime,
        // endTime:this.search.endTime.replace(/00:00:00/,"23:59:59"),
      }).then((data) => {
        if (data.status != 200) return;
        //翻页
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        _this.getPage(pageObj);
        _this.tableListData.rows = data.data.rows;
        // console.log(_this.tableListData.rows)
        _this.$nextTick(() => {
          // _this.$refs.table.doLayout()
        });
      });
    },

    tableListAll: function () {
      this.$get(getconlog(), {}).then((data) => {
        this.tableListDataAll = data;
      });
    },
    searchList: function () {
      var flTime = this.timeCompare(this.search.startTime, this.search.endTime);
      // console.log(this.search.endTime)
      if (flTime) {
        return this.$layer.msg("开始时间请勿大于结束时间", { time: 1 });
      } else if (
        !Boolean(this.search.startTime) &&
        Boolean(this.search.endTime)
      ) {
        return this.$layer.msg("请选择开始时间", { time: 1 });
      } else if (
        Boolean(this.search.startTime) &&
        !Boolean(this.search.endTime)
      ) {
        return this.$layer.msg("请选择结束时间", { time: 1 });
      }
      this.search.pageNumber = "1";
      this.tableList(this.search.pageNumber);
    },
    timeCompare: function (bDateVal, eDateVal) {
      if (!Boolean(bDateVal) || !Boolean(eDateVal)) {
        return false;
      }
      var bdate = new Date(Date.parse(bDateVal.replace(/-/g, "/")));
      bdate = bdate.getTime();
      var edate = new Date(Date.parse(eDateVal.replace(/-/g, "/")));
      edate = edate.getTime();
      if (bdate - edate > 0) {
        return true;
      } else {
        return false;
      }
    },
    clearSearch: function () {
      this.search.pageNumber = "1";
      this.search.type = "";
      this.search.startTime = "";
      this.search.endTime = "";
    },
  },
  computed: mapState({
    curIndex: (state) => state.page.curIndex,
    rowsCount: (state) => state.page.rowsCount,
  }),
  components: {
    Page,

    Refresh,
  },
  created: function () {},
  mounted: function () {
    this.tableList(this.search.pageNumber);
    // this.tableListAll();
  },
};
</script>
<style scoped>
/* @import '@/assets/css/equip.css'; */
.list {
  padding: 0 !important;
}
.table thead {
  background: #f9f9fb;
}
.searchbox .el-input {
  width: 180px !important;
}
</style>